import React from "react";
import PropTypes from "prop-types";
import SectionBlock from "./components/section-block";
import CreditAppraisalProductDetails from "../credit-appraisal-product-details";
import { SECTION_IDS } from "./constants";

export const PRODUCT_DETAILS_PRODUCT_TYPES = [8, 10, 12];

export const hasProductDetails = caseDetail => {
    if (!caseDetail) {
        return false;
    }
    const productType = caseDetail.get
        ? caseDetail.get("business_product_type")
        : caseDetail.business_product_type;
    return PRODUCT_DETAILS_PRODUCT_TYPES.includes(Number(productType));
};

const ProductDetailsSection = ({
    innerRef,
    caseId,
    caseDetail,
    recreditViewOnlyPermission,
    expanded,
    onToggle
}) => {
    if (!hasProductDetails(caseDetail)) {
        return null;
    }
    return (
        <SectionBlock
            id={SECTION_IDS.PRODUCT_DETAILS}
            innerRef={innerRef}
            title={"Product Details"}
            icon={"profile"}
            expanded={expanded}
            onToggle={onToggle}
        >
            <div className={"cc-product-details"}>
                <CreditAppraisalProductDetails
                    caseId={caseId}
                    recreditViewOnlyPermission={recreditViewOnlyPermission}
                    bare
                />
            </div>
        </SectionBlock>
    );
};

ProductDetailsSection.propTypes = {
    innerRef: PropTypes.object,
    caseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    caseDetail: PropTypes.object,
    recreditViewOnlyPermission: PropTypes.bool,
    expanded: PropTypes.bool,
    onToggle: PropTypes.func
};

export default ProductDetailsSection;
